import config from '@angular/config';

import newsfeedHeaderUrl from './newsfeed-header.html';

class NewsfeedHeaderCtrl {
  constructor(Authentication, NewsfeedCollection, $state, $transitions, $scope) {
    'ngInject';

    Object.assign(this, { Authentication, NewsfeedCollection, $state, $transitions, $scope });
  }

  get canUnfollow() {
    return !this.activePage.required && this.activePage.subscribed;
  }

  get canManagePage() {
    return (
      this.activePage?.id && (this.Authentication.user.isManager || this.activePage.owner.isMe)
    );
  }

  get shouldDisplayDropdown() {
    return (
      this.activePage?.id &&
      ((this.canManagePage && this.canPostArticle) ||
        this.canUnfollow ||
        !this.activePage.subscribed)
    );
  }

  get isSearchScreen() {
    return this.$state.current.name === 'newsfeed.view.search' && !this.$state.params.articleId;
  }

  get cancelSearch() {
    if (this.isSearchScreen) {
      return this.onClearSearch;
    }

    return null;
  }

  $onChanges = (changes) => {
    if (!changes.activePage) {
      return;
    }

    this.canCreatePages =
      !this.activePage?.id && this.NewsfeedCollection.canPageBeCreatedBy(this.Authentication.user);
    this.canPostArticle =
      this.activePage?.id &&
      this.NewsfeedCollection.canPostArticle(this.activePage, this.Authentication.user);
    this.employeeCanActOnPage =
      this.activePage?.id &&
      this.NewsfeedCollection.employeeCanActOnPage(this.activePage, this.Authentication.user);
  };

  $onInit() {
    this.articleSearchEnabled = config.ARTICLE_SEARCH_ENABLED;
    this.activeQuery = !this.$state.params.articleId ? this.$state.params.query : '';

    this.$transitions.onSuccess({}, () => {
      this.activeQuery = this.$state.params.query || '';
    });

    this.$transitions.onSuccess({ exiting: 'newsfeed.view.search' }, (transition) => {
      if (transition.to().name !== 'newsfeed.view.search') {
        this.activeQuery = '';
      }
    });

    this.$scope.$on('$locationChangeSuccess', () => {
      const { articleId, query } = this.$state.params;
      this.activeQuery = !articleId && query ? this.$state.params.query : '';
    });

    this.$scope.$watch('ctrl.activeQuery', (query) => {
      if (!this.isSearchScreen) {
        this.onQueryUpdate?.({ query });
      }
    });
  }

  onSubmitSearch = (query) => {
    this.onQueryUpdate?.({ query: '' });

    if (!query) {
      this.$state.go('newsfeed.view');
      return;
    }

    const params = {
      query,
      pageId: this.activePage?.id || 0,
      articleId: null,
    };

    this.$state.go('newsfeed.view.search', params);
  };

  onSearchQueryChange = (query) => {
    if (this.isSearchScreen) {
      return;
    }

    this.activeQuery = query;
  };

  onClearSearch = () => {
    this.activeQuery = '';
    if (this.activePage?.id) {
      this.$state.go('newsfeed.view.page', { pageId: this.activePage.id });
      return;
    }

    this.$state.go('newsfeed.view.mynewsfeed');
  };
}

export default {
  controller: NewsfeedHeaderCtrl,
  controllerAs: 'ctrl',
  bindings: {
    activePage: '<',
    followPage: '&',
    unfollowPage: '&',
    createPage: '&',
    editPage: '&',
    deletePage: '&',
    membersPanelOpened: '<',
    membersToggle: '&',
    onQueryUpdate: '&',
  },
  templateUrl: newsfeedHeaderUrl,
};
